import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installFetchInterceptor } from './services/session';

installFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
// Application installable et utilisable sans réseau (rapport journalier hors connexion)
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
